import { render, staticRenderFns } from "./EditForms.vue?vue&type=template&id=1bc98208&scoped=true"
import script from "./EditForms.vue?vue&type=script&lang=js"
export * from "./EditForms.vue?vue&type=script&lang=js"
import style0 from "./EditForms.vue?vue&type=style&index=0&id=1bc98208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc98208",
  null
  
)

export default component.exports